export default {
    title: "",
    subtitle: "",
    path: "refund_transaction_list",
    paragraph: "To check the transactions which were refunded, you can use this other endpoint:",
    request:  {
      method: "GET",
      endpoint: "/bank_transactions/refunded",
      responses: {
            "data": [
                {
                    "transaction_kind": 2,
                    "status": "wired",
                    "reason": "Some reason for refund",
                    "inserted_at": "2025-04-07T18:31:18.208487",
                    "id": "3a6a9ca1-b7a1-40c1-b0cf-af0f733da7bd",
                    "bank_transaction": {
                        "wire_id": "39afb77b-5483-4934-b3b1-033e9d5cb785",
                        "value": "10000.00",
                        "spei_reference": null,
                        "spei_concepto_de_pago": null,
                        "source_type": "PIX",
                        "source_name": "Company Ltda.",
                        "source_id": null,
                        "source_document_type": "cnpj",
                        "source_document_number": "93535445000157",
                        "source_description": "CREDITO POR TED",
                        "source_branch": "5052",
                        "source_bank_ispb": "23273917",
                        "source_bank": null,
                        "source_account": "1251058725246183",
                        "movement_date": "2025-04-07",
                        "iof_value": "0.00",
                        "inserted_at": "2025-04-07T16:20:32.197678",
                        "id": "1676ae9b-bc08-416f-ae2e-56d28f9a9e52",
                        "exchanged_value": "10000.00",
                        "exchange_rate_spot": null,
                        "exchange_rate": "1.0",
                        "exchange_id": "e5ba4a1a-6566-465d-8986-ab7e326a3830",
                        "exchange_currency": "BRL",
                        "exchange_approved": true,
                        "currency": "BRL"
                    }
                }
            ]
        }
    },
    queryPayload: [
      {
        name: "last_id",
        type: "string",
        required: false,
        description: "Last transaction UUID for pagination"
      },
      {
        name: "per_page",
        type: "string",
        required: false,
        description: "Number of elements per page"
      }
    ]
  }



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/RefundTransactionsList.js